import BlogGridView from "../../../commonComponents/blogGridView";

const BlogRightListContainer = () => {
  return <BlogGridView sectionClass="blog-list-section" side="right" gridSize={1} />;
};

export default BlogRightListContainer;
